export const DoppeActionTypeFollowViewerLang = {
    defaultTexts: {
        followButtonText: 'Follow',
        followers: '100K followers',
        posts: '567 posts',
        nickName: '@nickname',
    }
}